<!-- 设置 -->
<template>
  <div class="grid-view tab-fcl-setting">
    <div style="margin: 10px;">
      <el-button no="onSave" type="success" @click="onSave()">{{ $t('Pricing.Save') }}</el-button>
      <el-button no="onRefresh" type="primary" @click="onRefresh()">{{ $t('Pricing.Refresh') }}</el-button>
      <el-button no="onAdd" type="primary" @click="onAdd()">{{ $t('Pricing.Add') }}</el-button>
      <el-button no="onDel" type="danger" :disabled="!selectedCount" @click="onDel()">{{ $t('Pricing.Delete') }}</el-button>
      <el-button no="onCancel" type="success" @click="onCancel()">{{ $t('Pricing.Cancel') }}</el-button>
    </div>
    <div class="search">
      <span class="label-center">{{ $t('Pricing.Search') }}</span>
      <span class="label-center">{{ $t('Pricing.RegionOrCarrier') }}</span>
      <el-input v-model="searchValue" no="searchValue" style="flex: 1" />
    </div>
    <markup-fcl-data-grid
      ref="markupGrid"
      :config-module="'22130203'"
      :row-data="filterData"
      style="width: 100%"
      :editable="true"
      :grid-options="gridOptions"
    />
  </div>
</template>

<script>

import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor/index'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor/index'
import CargoAgGridPopSelectInput from '@/components/Cargo/Common/CargoAgGridPopSelectInput'
import FclDataGrid from '@/views/cargo/v0/Price/components/grid/fclDataGrid'
import MarkupFclDataGrid from '@/views/cargo/v0/Price/PriceFCL/components/PriceFCL/markupFclDataGrid'
import { FclApproveSettings } from '@/views/cargo/v0/Price/PriceFCL/components/PriceFCL/fclApproveSettings'
import { saveOrUpdateConfig } from '@/api/user'
import { MultiCompanyUtil } from '@/class/cargo/model/utils/MultiCompanyUtil'
import * as PriceConstant from '@/class/cargo/model/parameters/PriceConstant'
import StrUtils from '@/utils/StrUtils'
export default {
  name: 'TabFclApproveSettings',
  components: { MarkupFclDataGrid, FclDataGrid },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      searchValue: '',
      rowData: [],
      source: [],
      selectedCount: 0,
      cfg: null,
      isHQManager: false,
      fullscreenLoading: false,
      hasAdd: false,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        // 单击显示编辑
        singleClickEdit: true,
        // 添加编辑组件
        frameworkComponents: {
          CargoAgGridSelectEditor,
          CargoAgGridAdvanceSelectEditor,
          CargoAgGridCommonInputEditor,
          CargoAgGridPopSelectInput
        },
        onSelectionChanged: event => {
          const rows = event.api.getSelectedRows()
          this.selectedCount = rows.length
        }
      }
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    },
    filterData() {
      const { searchValue, source } = this
      if (!searchValue.trim()) {
        return source
      } else {
        const filterKeys = ['rol', 'rod', 'carrier']
        return source.filter(row => {
          for (let i = 0; i < filterKeys.length; i++) {
            const key = filterKeys[i]
            let value = ''
            if (key === 'rol') {
              value = this.$refs['markupGrid'].filterPolLabelFunc(row)
            }
            if (key === 'rod') {
              value = this.$refs['markupGrid'].filterPodLabelFunc(row)
            }
            if (key === 'carrier') {
              value = this.$refs['markupGrid'].filterDataGridColumnCarrierFunc(row[key])
            }
            if (row[key] && value.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1) return true
          }
        })
      }
    }
  },
  watch: {},
  methods: {
    init(fclConfigUtil) {
      this.isHQManager = MultiCompanyUtil.getInstance().isHQManager('PriceFcl')
      this.markupSelectRow = null
      this.fclConfigUtil = fclConfigUtil
      if (this.fclConfigUtil['_isMarkupSettingsLoaded']) {
        this.onSettingsLoaded()
      }
    },
    onSettingsLoaded() {
      this.cfg = this.fclConfigUtil.markupCfg
      if (!this.cfg) {
        if (this.fclConfigUtil.markupCfgDef) {
          this.cfg = {}
          this.fclConfigUtil.markupCfg = this.cfg
          if (this.isHQManager) {
            this.cfg.officeId = 1
          } else {
            this.cfg.officeId = this.$store.getters.currentOfficeId
          }
          this.cfg.isOverrideable = false
          this.cfg.configId = this.fclConfigUtil.markupCfgDef.configId
          this.cfg.value = {}
        } else {
          this.$message.warning(this.$t('Pricing.NoSetting'))
          return
        }
      }
      this.decodeSetting()
    },
    decodeSetting() {
      if (this.fclConfigUtil.markupCfg.value.indexOf('setting') > 0) {
        const cfg = this.fclConfigUtil.markupCfgValue['setting']
        if (cfg === null) {
          this.source = []
          return
        }
        const sources = []
        cfg.forEach(item => {
          const data = new FclApproveSettings(item)
          // 因为起运地和目的港对应的字段是根据起运地类型以及目的地类型变更的，所以需要试用临时字段去处理显示列字段绑定问题
          if (data.polType === 0) {
            data.polColumn = data.rol
          } else if (data.polType === 1) {
            data.polColumn = data.col
          } else if (data.polType === 2) {
            data.polColumn = data.pol
          }
          if (data.podType === 0) {
            data.podColumn = data.rod
          } else if (data.podType === 1) {
            data.podColumn = data.cod
          } else if (data.podType === 2) {
            data.podColumn = data.pod
          }
          sources.push(data)
        })
        this.source = sources
      } else {
        this.source = []
      }
    },
    onSave() {
      if (!this.isValid()) {
        return false
      }
      // 保存的时候要重新计算polMap，podMap
      if (this.source && this.source.length > 0) {
        for (const item of this.source) {
          item.polMap = {}
          item.podMap = {}
          new FclApproveSettings(item).calcHashCode()
          if (item.hasOwnProperty('polColumn')) {
            delete item.polColumn
          }
          if (item.hasOwnProperty('podColumn')) {
            delete item.podColumn
          }
        }
      }
      this.cfg.value = JSON.stringify({ setting: this.source })
      saveOrUpdateConfig(this.cfg).then((res) => {
        this.$message.success(this.$t('Pricing.Finished'))
        this.fclConfigUtil.markupCfg = res.data
        this.fclConfigUtil.decodeMarkupSetting()
        this.hasAdd = false
        this.onCancel()
      })
    },
    onRefresh() {
      this.decodeSetting()
      this.selectedCount = 0
    },
    onAdd() {
      const data = new FclApproveSettings({})
      data.polColumn = 'ALLRG'
      data.podColumn = 'ALLRG'
      data.rol = data.polColumn
      data.col = data.polColumn
      data.pol = data.polColumn
      data.rod = data.podColumn
      data.cod = data.podColumn
      data.pod = data.podColumn
      this.source.push(data)
      this.hasAdd = true
    },
    onDel() {
      const api = this.gridOptions.api
      const selRows = api.getSelectedRows() // 获取选中的行
      api.updateRowData({ remove: selRows })
      const rowData = []
      api.forEachNode(node => rowData.push(node.data))
      this.source = rowData
      this.selectedCount = 0
    },
    onCancel() {
      if (this.hasAdd) {
        this.$confirm(this.$t('Pricing.NotSave'), this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          this.onSave()
        }).catch(() => {
          this.$emit('close')
        })
      } else {
        this.$emit('close')
      }
    },
    isValid() {
      if (this.source !== null && this.source.length > 1) { // 检查起运地或目的地是否为空
        let validRegion = false
        this.gridOptions.api.forEachLeafNode((node) => {
          const polResult = this.validRegion(node, 'polType', PriceConstant.POL_TYPE)
          if (!polResult) {
            validRegion = true
            return false
          }
          const podResult = this.validRegion(node, 'podType', PriceConstant.POD_TYPE)
          if (!podResult) {
            validRegion = true
            return false
          }
        })
        if (validRegion) {
          return false
        }
        // 检查是否存在重复项
        const len = this.source.length
        const len1 = len - 1
        let isOverlap = false
        for (let i = 0; i < len1; i++) {
          for (let j = i + 1; j < len; j++) {
            if (this.source[i].isOverlap(this.source[j])) {
              this.source[i]['repeat'] = true
              this.source[j]['repeat'] = true
              isOverlap = true
              break
            }
          }
        }
        if (isOverlap) {
          this.gridOptions.api.forEachLeafNode((node) => {
            if (node.data['repeat']) {
              node.setSelected(true)
              delete node.data.repeat
            }
          })
          this.$message.warning(this.$t('Pricing.SettingOverlap'))
          return false
        }
      }
      return true
    },
    validRegion(node, type, fields) {
      const regionType = node.data[type]
      const field = fields[regionType]
      if (StrUtils.isEmpty(node.data[field])) {
        node.setSelected(true)
        this.$message.warning(StrUtils.substitute(this.$t('Pricing.SettingNoRegion'), this.$t('Pricing.' + field.toUpperCase())))
        return false
      }
      return true
    }
  }
}
</script>

<style  lang="scss" scoped>
  .tab-fcl-setting {
    .search{
      display: flex;flex: 1;
      position: absolute;
      right:0;
      top: 0;
      margin-right: 20px;
      margin-top: 10px;
      .label-center{
        align-self:center;
        margin-right: 5px;
      }
    }
  }
</style>
